import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { ContactRolesFetchedAction } from '@Application/Beneficiaries/BeneficiaryContacts/ContactRoles/Actions/contactRolesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type ContactRolesStore = {
	contactRoles: readonly LabeledValueView[] | null;
};

const initialState: ContactRolesStore = {
	contactRoles: null,
};

type Actions = ContactRolesFetchedAction | UserRevokedAction;

const whenContactRolesFetched = (
	store: ContactRolesStore,
	action: ContactRolesFetchedAction,
): ContactRolesStore => ({
	...store,
	contactRoles: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): ContactRolesStore => initialState;

export default registerStore<'contactRolesStore', Actions>(
	'contactRolesStore',
	createSliceReducer({
		CONTACT_ROLES_FETCHED: whenContactRolesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
